export type IconId = string;

type IconRecord = {
    image: HTMLImageElement;
    ready: boolean;
};

type IconRegistryOptions = {
    onReady?: () => void;
    createImage?: () => HTMLImageElement;
};

export class IconRegistry {
    private icons = new Map<IconId, IconRecord>();
    private onReady?: () => void;
    private createImage: () => HTMLImageElement;

    constructor(options: IconRegistryOptions = {}) {
        this.onReady = options.onReady;
        this.createImage =
            options.createImage ??
            (() => (typeof Image === 'undefined' ? ({} as HTMLImageElement) : new Image()));
    }

    register(id: IconId, src: string): void {
        if (this.icons.has(id)) return;
        const image = this.createImage();
        const record: IconRecord = { image, ready: false };
        this.icons.set(id, record);
        image.onload = () => {
            const current = this.icons.get(id);
            if (!current) return;
            current.ready = true;
            if (this.onReady) this.onReady();
        };
        if ('src' in image) {
            image.src = src;
            if (image.complete) {
                record.ready = true;
                if (this.onReady) this.onReady();
            }
        }
    }

    isReady(id: IconId): boolean {
        return this.icons.get(id)?.ready ?? false;
    }

    get(id: IconId): HTMLImageElement | null {
        return this.icons.get(id)?.image ?? null;
    }
}
